import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1875 11H2.8125C2.025 11 1.5 11.4 1.5 12C1.5 12.6 2.025 13 2.8125 13H21.1875C21.975 13 22.5 12.6 22.5 12C22.5 11.4 21.975 11 21.1875 11Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1875 5H2.8125C2.025 5 1.5 5.4 1.5 6C1.5 6.6 2.025 7 2.8125 7H21.1875C21.975 7 22.5 6.6 22.5 6C22.5 5.4 21.975 5 21.1875 5Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1875 17H2.8125C2.025 17 1.5 17.4 1.5 18C1.5 18.6 2.025 19 2.8125 19H21.1875C21.975 19 22.5 18.6 22.5 18C22.5 17.4 21.975 17 21.1875 17Z",
			fill: "#636C7B"
		})
	]
});
export default SvgMenuTab;
